<div *ngIf="!noData" class="echarts" id="charts" echarts [options]="chartOption"></div>
<div *ngIf="noData" class="no-data">No Schedule Available</div>